import { useState, useEffect } from 'react';
import { getLinkedInLink, InfoCard, InfoCardItem } from './InfoCard';
import { DirectoryBaseOrgInfo } from '@platform/client/schemas';

export const OrgInfoCard = ({
  isLoaded,
  orgData,
}: {
  isLoaded: boolean;
  orgData: DirectoryBaseOrgInfo;
}) => {
  const [infoCardItems, setInfoCardItems] = useState<InfoCardItem[]>([]);

  useEffect(() => {
    if (!isLoaded || !orgData) {
      return;
    }

    const items: InfoCardItem[] = [];

    if (orgData?.websiteUrl) {
      items.push({ type: 'website', url: orgData.websiteUrl });
    }

    if (orgData?.linkedinName) {
      items.push({
        type: 'linked-in',
        // TODO: Not universal, need to inspect other orgs' linked in urls
        accountName: getLinkedInLink(orgData.linkedinName), // org.linkedinName.replace('https://www.linkedin.com/company/', ''),
      });
    }

    if (orgData.teamSize) {
      items.push({ type: 'team-size', size: orgData.teamSize });
    }

    if (orgData.dateEstablished) {
      items.push({ type: 'established-date', date: orgData.dateEstablished });
    }

    if (orgData.organizationType) {
      items.push({ type: 'org-type', orgType: orgData.organizationType });
    }

    setInfoCardItems(items);
  }, [isLoaded, orgData]);

  return <InfoCard items={infoCardItems} />;
};
